// AssistantThreadUrlSync — the invisible shell-root sentinel that keeps the
// address bar and the main thread in step: every main-thread conversation has
// its own URL, `?ai=<conversationId>` (Nika 2026-09-30; the whole rule lives in
// functions/assistantThreadUrl.js).
//
// It holds no logic. It names the keys the reconcile reads and runs it when
// one of them moves — `subscribeTo` + `onUpdate`, the shell's reliable
// route-reactive path (the ShellRouteSync / ShellSkinSync sentinels in app.js
// are the same shape):
//   • the thread — its flag, the route it opened on, its conversation;
//   • the placement, and the page sheet that covers the main area;
//   • the route — `_routeNudge` moves on EVERY navigation the router makes, a
//     query-only one and Back / Forward included;
//   • the AI service and the workspace a link waits for.
// One instance, mounted at the shell root (app.js), so it lives on every route
// and across a workspace switch — the reconcile keeps the thread it last saw
// open on THIS element (`el.__aiThreadAgreed`), where no state wipe reaches.
export const AssistantThreadUrlSync = {
  tag: 'div',
  display: 'none',
  subscribeTo: [
    '_homeThreadOpen',
    '_mainThreadPath',
    'activeSessionId',
    'assistantDock',
    '_canvasSlot',
    '_canvasSlotSecond',
    'currentPath',
    '_routeNudge',
    '_aiSvcReady',
    'workspace'
  ],
  onCreate: (el) => el.call('assistantThreadUrlReconcile'),
  onUpdate: (el) => el.call('assistantThreadUrlReconcile')
}
